import React from 'react';
import Activity_item from '../../components/collectrions/Activity_item';
import Meta from '../../components/Meta';

const index = () => {
  return (
    <>
      <Meta title='Activity || Bit5 | Create. Collect. Connect.' />
      <section className='relative pb-24 lg:pb-48'>
        <picture className='pointer-events-none absolute inset-0 -z-10 dark:hidden'>
          <img src='/images/gradient_light.jpg' alt='gradient' className='h-full w-full' />
        </picture>
        <div className='container'>
          <h1 className='py-16 text-center font-display text-4xl font-medium text-jacarta-700 dark:text-white'>
            Activity
          </h1>
          <Activity_item getAllActivities='true' showChainFilter />
        </div>
      </section>
    </>
  );
};

export default index;
